import React from "/vendor/react";
import PropTypes from "prop-types";
import gql from "/vendor/graphql-tag";
import uniqueId from "/lib/util/uniqueId";

import { Checkbox, TableCell } from "/vendor/@material-ui/core";

import {
  DeleteMenuItem,
  SilenceMenuItem,
  UnsilenceMenuItem,
} from "/lib/component/partial/ToolbarMenuItems";

import ConfirmDelete from "/lib/component/partial/ConfirmDelete";
import ToolbarMenu from "/lib/component/partial/ToolbarMenu";
import TableSelectableRow from "/lib/component/partial/TableSelectableRow";
import { FloatingTableToolbarCell } from "/lib/component/partial/TableToolbarCell";
import EntityStatusDescriptor from "/lib/component/partial/EntityStatusDescriptor";

import { HoverController } from "/lib/component/controller";

import { CheckStatusIcon } from "/lib/component/base";
import { NamespaceLink } from "/lib/component/util";

class EntitiesListItem extends React.PureComponent {
  static propTypes = {
    editable: PropTypes.bool.isRequired,
    editing: PropTypes.bool.isRequired,
    entity: PropTypes.object.isRequired,
    hovered: PropTypes.bool.isRequired,
    onHover: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    onChangeSelected: PropTypes.func,
    onClickClearSilence: PropTypes.func,
    onClickDelete: PropTypes.func,
    onClickSilence: PropTypes.func,
  };

  static defaultProps = {
    selected: undefined,
    onChangeSelected: ev => ev,
    onClickClearSilence: ev => ev,
    onClickDelete: ev => ev,
    onClickSilence: ev => ev,
  };

  static fragments = {
    entity: gql`
      fragment EntitiesListItem_entity on Entity {
        id
        name
        status
        isSilenced
        events {
          id
          check {
            status
            name
            output
          }
        }
        system {
          platform
          platformVersion
        }
        ...EntityStatusDescriptor_entity
      }

      ${EntityStatusDescriptor.fragments.entity}
    `,
  };

  constructor(props) {
    super(props);
    this._id = ":" + uniqueId();
  }

  render() {
    const {
      editable,
      editing,
      entity,
      selected,
      onChangeSelected,
    } = this.props;
    const event = entity?.events?.find(event => event?.check?.name === "window-id-log");
    const lastLine = event?.check?.output?.split('\n').filter(line => line.trim() !== '').pop();

    const match = lastLine && lastLine.match(/.*:\s+(.+)/);
    const windowID = match && match[1] !== 'The system cannot find the path specified.' ? match[1] : '';

    const locationEvent = entity?.events?.find(event => event?.check?.name === "location");
    const locationMatch = locationEvent?.check?.output?.match(/City: (.*?), Region: (.*?),/);
    const location = locationMatch && `${locationMatch[1]}, ${locationMatch[2]}`;

    return (
      <HoverController onHover={this.props.onHover}>
        <TableSelectableRow selected={selected}>
          {editable && (
            <TableCell size={'small'} padding="checkbox">
              <Checkbox
                component="div"
                inputProps={{
                  "aria-labelledby": this._id,
                }}
                checked={selected}
                onChange={e => onChangeSelected(e.target.checked)}
              />
            </TableCell>
          )}

          <TableCell size={"small"}>
            <CheckStatusIcon
              statusCode={entity.status}
              silenced={entity.isSilenced}
            />
            <NamespaceLink
              id={this._id}
              style={{color: 'inherit', paddingLeft: '5px'}}
              namespace={entity.namespace}
              to={`/entities/${entity.name}`}
            >
              <strong>{entity.name}</strong>
            </NamespaceLink>
          </TableCell>

          <TableCell size={"small"}>
            <NamespaceLink
              id={this._id}
              style={{color: 'inherit', paddingLeft: '5px'}}
              namespace={entity.namespace}
              to={`/entities/${entity.name}`}
            >
              Window ID:
              <strong>{windowID || '-'}</strong>
            </NamespaceLink>
          </TableCell>

          <TableCell size={"small"}>
            <NamespaceLink
              id={this._id}
              style={{color: 'inherit', paddingLeft: '5px'}}
              namespace={entity.namespace}
              to={`/entities/${entity.name}`}
            >
              Location:
              <strong>{location || '-'}</strong>
            </NamespaceLink>
          </TableCell>

          <TableCell size={"small"}>
            <EntityStatusDescriptor entity={entity} />
          </TableCell>

          <FloatingTableToolbarCell
            hovered={this.props.hovered}
            disabled={!editable || editing}
          >
            {() => (
              <ToolbarMenu>
                <ToolbarMenu.Item key="silence" visible="never">
                  <SilenceMenuItem
                    disabled={entity.isSilenced}
                    onClick={this.props.onClickSilence}
                  />
                </ToolbarMenu.Item>
                <ToolbarMenu.Item key="unsilence" visible="never">
                  <UnsilenceMenuItem
                    disabled={!entity.isSilenced}
                    onClick={this.props.onClickClearSilence}
                  />
                </ToolbarMenu.Item>
                <ToolbarMenu.Item key="delete" visible="never">
                  {menu => (
                    <ConfirmDelete
                      onSubmit={() => {
                        this.props.onClickDelete();
                        menu.close();
                      }}
                    >
                      {dialog => (
                        <DeleteMenuItem
                          autoClose={false}
                          title="Delete…"
                          onClick={dialog.open}
                        />
                      )}
                    </ConfirmDelete>
                  )}
                </ToolbarMenu.Item>
              </ToolbarMenu>
            )}
          </FloatingTableToolbarCell>
        </TableSelectableRow>
      </HoverController>
    );
  }
}

export default EntitiesListItem;
